import { ViewFilterAlignment } from '../../enums'
import { FieldDefinition } from '../../field-definitions'
import { DefinitionUtils } from '../../utils'

export class FilterDefinition {
  public inlineDefinition: FieldDefinition
  public parameterKey: string
  public readOnly: boolean
  public visible: boolean
  public applyOnChange: boolean
  public customUI: string
  public alignment: ViewFilterAlignment
  public defaultValue: string
  public hideInFiltersDialog: boolean

  constructor(model: FilterDefinition) {
    this.parameterKey = model.parameterKey
    this.readOnly = model.readOnly
    this.visible = model.visible
    this.applyOnChange = model.applyOnChange
    this.defaultValue = model.defaultValue
    this.customUI = model.customUI
    this.alignment = model.alignment
    this.inlineDefinition = DefinitionUtils.mapFieldDefinition(model.inlineDefinition)
    this.hideInFiltersDialog = model.hideInFiltersDialog
  }
}
